import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {GarantiasIdoneas} from '../_models/garantias-idoneas';
import {GarantiasIdoneasDestino} from '../_models/garantias-idoneas-destino';
import {GarantiasIdoneasMunicipio} from '../_models/garantias-idoneas-municipio';
import {Observable} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GarantiaIdoneasMunicipioService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasMunicipios';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as GarantiasIdoneasMunicipio[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as GarantiasIdoneasMunicipio[] ) );
  }

  listadoPorMunicipios(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id ).pipe( map( res => res as GarantiasIdoneasMunicipio[] ) );
  }

  listadoPorMunicipiosActivos(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id + '/enabled').pipe( map( res => res as GarantiasIdoneasMunicipio[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as GarantiasIdoneasMunicipio ) );
  }

  crear( regCrear: GarantiasIdoneasMunicipio ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as GarantiasIdoneasMunicipio ) );
  }

  actualizar( regActualizar: GarantiasIdoneasMunicipio ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( segmentoActividades: GarantiasIdoneasMunicipio[] ): Observable<GarantiasIdoneasMunicipio[]> {
    segmentoActividades.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', segmentoActividades ).pipe( map( res => res as GarantiasIdoneasMunicipio[] ) );
  }
}
